// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared table design matching AdminManagement - for use with GenericTable wrapper */

.ManagementTable_managementPage__gh0bq {
  min-height: calc(100vh - 60px);
  background: #f8f9fa;
  padding: 1.5rem;
  color: #000000;
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
}

.ManagementTable_header__FBHCB {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
  gap: 1rem;
}

.ManagementTable_headerLeft__s5tvl {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.ManagementTable_headerIcon__BHDpe {
  color: #87ceeb;
}

.ManagementTable_title__cDm3- {
  font-size: 1.5rem;
  font-weight: 700;
  color: #000000;
  margin: 0;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.ManagementTable_addButton__Mg3I7 {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.625rem 1.25rem;
  background: #000000;
  color: #ffffff;
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.ManagementTable_addButton__Mg3I7:hover {
  background: #001f3f;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.ManagementTable_searchBarRow__larbN {
  margin-bottom: 1rem;
}

.ManagementTable_tableContainer__jInCR {
  background: #ffffff;
  border: 1px solid rgba(135, 206, 235, 0.3);
  border-radius: 0.5rem;
  overflow-x: auto;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

/* Override Chakra table when inside .tableContainer */
.ManagementTable_tableContainer__jInCR table {
  width: 100%;
  border-collapse: collapse;
  min-width: 800px;
}

.ManagementTable_tableContainer__jInCR thead {
  background: linear-gradient(135deg, #000000 0%, #001f3f 50%, #000000 100%);
  color: #ffffff;
}

.ManagementTable_tableContainer__jInCR thead th {
  padding: 1rem;
  text-align: left;
  font-size: 0.875rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 2px solid rgba(255, 255, 255, 0.1);
  background: linear-gradient(135deg, #000000 0%, #001f3f 50%, #000000 100%) !important;
  color: #ffffff !important;
  white-space: nowrap;
  border: none !important;
}

.ManagementTable_tableContainer__jInCR tbody tr {
  border-bottom: 1px solid rgba(135, 206, 235, 0.3);
  transition: all 0.2s ease;
}

.ManagementTable_tableContainer__jInCR tbody tr:hover {
  background: rgba(135, 206, 235, 0.05);
}

.ManagementTable_tableContainer__jInCR tbody td {
  padding: 1rem;
  font-size: 0.875rem;
  color: #000000;
  white-space: nowrap;
  border: none !important;
  border-bottom: 1px solid rgba(135, 206, 235, 0.3) !important;
}

.ManagementTable_tableContainer__jInCR tbody tr:last-child td {
  border-bottom: none !important;
}

.ManagementTable_loadingContainer__SJ09C {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
}

.ManagementTable_spinner__4LCqQ {
  color: #87ceeb;
  animation: ManagementTable_spin__1hb2j 1s linear infinite;
}

@keyframes ManagementTable_spin__1hb2j {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.ManagementTable_errorAlert__-XloS {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem;
  background: #ff6b6b;
  color: white;
  border-radius: 0.5rem;
  margin-bottom: 1.5rem;
  font-weight: 500;
}

/* Action buttons - icon style matching AdminManagement */
.ManagementTable_actionButtons__HE4hm {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.ManagementTable_iconButton__8-wZ- {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  background: transparent;
  border: 1px solid rgba(135, 206, 235, 0.3);
  border-radius: 0.375rem;
  color: #000000;
  cursor: pointer;
  transition: all 0.2s ease;
}

.ManagementTable_iconButton__8-wZ-:hover {
  background: rgba(135, 206, 235, 0.1);
  border-color: #87ceeb;
  color: #87ceeb;
}

.ManagementTable_iconButton__8-wZ-:active {
  transform: scale(0.95);
}

.ManagementTable_iconButtonDelete__zFQUu:hover {
  background: rgba(255, 107, 107, 0.1);
  border-color: #ff6b6b;
  color: #ff6b6b;
}

.ManagementTable_statusBadge__KoWjt {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 1rem;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.ManagementTable_statusActive__6w1zP {
  background: rgba(67, 160, 71, 0.1);
  color: #43a047;
}

.ManagementTable_statusInactive__cRB7\\+ {
  background: rgba(255, 107, 107, 0.1);
  color: #ff6b6b;
}

/* ============================================
   Modal (AdminManagement-style)
   ============================================ */
.ManagementTable_modalOverlay__X0UOm {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
}

.ManagementTable_modal__Tf53U {
  background: #ffffff;
  border-radius: 0.5rem;
  width: 100%;
  max-width: 800px;
  max-height: calc(100vh - 2rem);
  max-height: calc(100dvh - 2rem);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}

.ManagementTable_modalForm__aZRkL {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.ManagementTable_modalHeader__X95I0 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.25rem 1.5rem;
  background: linear-gradient(135deg, #000000 0%, #001f3f 50%, #000000 100%);
  color: #ffffff;
  border-radius: 0.5rem 0.5rem 0 0;
  flex-shrink: 0;
}

.ManagementTable_modalTitle__qm0ti {
  font-size: 1.125rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  margin: 0;
}

.ManagementTable_closeButton__aGtsa {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  background: transparent;
  border: none;
  color: #ffffff;
  cursor: pointer;
  border-radius: 0.25rem;
  transition: all 0.2s ease;
}

.ManagementTable_closeButton__aGtsa:hover {
  background: rgba(255, 255, 255, 0.1);
}

.ManagementTable_modalBody__wQZec {
  padding: 1.5rem;
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  overscroll-behavior: contain;
}

.ManagementTable_modalFooter__OwhvL {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.75rem;
  padding: 1.25rem 1.5rem;
  border-top: 1px solid rgba(135, 206, 235, 0.3);
  background: #f8f9fa;
  border-radius: 0 0 0.5rem 0.5rem;
  flex-shrink: 0;
}

.ManagementTable_formGroup__H0bqd {
  margin-bottom: 1.25rem;
}

.ManagementTable_formSectionTitle__HR4y2 {
  margin: 0.5rem 0 0.75rem;
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #4a5568;
  border-bottom: 1px solid rgba(135, 206, 235, 0.3);
  padding-bottom: 0.35rem;
}

.ManagementTable_formGrid__RtOoQ {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.75rem 1rem;
}

.ManagementTable_formGrid__RtOoQ .ManagementTable_formGroup__H0bqd {
  margin-bottom: 0.5rem;
}

@media (max-width: 640px) {
  .ManagementTable_formGrid__RtOoQ {
    grid-template-columns: 1fr;
  }
}

.ManagementTable_label__qzYz7 {
  display: block;
  font-size: 0.875rem;
  font-weight: 600;
  color: #000000;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.ManagementTable_required__BhUVT {
  color: #ff6b6b;
}

.ManagementTable_input__lhDq0,
.ManagementTable_select__SBmS3 {
  width: 100%;
  padding: 0.625rem 0.875rem;
  font-size: 0.875rem;
  border: 1px solid rgba(135, 206, 235, 0.3);
  border-radius: 0.375rem;
  background: #ffffff;
  color: #000000;
  transition: all 0.2s ease;
  box-sizing: border-box;
}

.ManagementTable_input__lhDq0:focus,
.ManagementTable_select__SBmS3:focus {
  outline: none;
  border-color: #87ceeb;
  box-shadow: 0 0 0 3px rgba(135, 206, 235, 0.1);
}

.ManagementTable_input__lhDq0::placeholder {
  color: #4a5568;
}

.ManagementTable_select__SBmS3 {
  cursor: pointer;
}

.ManagementTable_switchLabel__SmRf- {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
  padding: 0.5rem 0;
}

.ManagementTable_switch__KVlUn {
  width: 40px;
  height: 20px;
  appearance: none;
  background: #cbd5e0;
  border-radius: 10px;
  position: relative;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.ManagementTable_switch__KVlUn:checked {
  background: #87ceeb;
}

.ManagementTable_switch__KVlUn::before {
  content: '';
  position: absolute;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #ffffff;
  top: 2px;
  left: 2px;
  transition: all 0.2s ease;
}

.ManagementTable_switch__KVlUn:checked::before {
  left: 22px;
}

.ManagementTable_switchText__Y4AWq {
  font-size: 0.875rem;
  font-weight: 500;
  color: #000000;
}

.ManagementTable_helpText__6gv4z {
  font-size: 0.8125rem;
  color: #4a5568;
  margin-left: 0.5rem;
  font-weight: normal;
  text-transform: none;
}

.ManagementTable_submitButton__YTmtQ {
  padding: 0.625rem 1.5rem;
  background: #87ceeb;
  color: #ffffff;
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.ManagementTable_submitButton__YTmtQ:hover {
  background: #6bb6d4;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(135, 206, 235, 0.3);
}

.ManagementTable_submitButton__YTmtQ:active {
  transform: translateY(0);
}

.ManagementTable_cancelButton__5HGEM {
  padding: 0.625rem 1.5rem;
  background: transparent;
  color: #000000;
  border: 1px solid rgba(135, 206, 235, 0.3);
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.ManagementTable_cancelButton__5HGEM:hover {
  background: rgba(135, 206, 235, 0.1);
  border-color: #87ceeb;
}

.ManagementTable_formError__11wDE {
  padding: 0.875rem 1rem;
  margin-bottom: 1rem;
  background: rgba(255, 107, 107, 0.1);
  color: #ff6b6b;
  border: 1px solid rgba(255, 107, 107, 0.3);
  border-radius: 0.5rem;
  font-size: 0.875rem;
}

.ManagementTable_modalBody__wQZec::-webkit-scrollbar {
  width: 8px;
}

.ManagementTable_modalBody__wQZec::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.ManagementTable_modalBody__wQZec::-webkit-scrollbar-thumb {
  background: #87ceeb;
  border-radius: 4px;
}

.ManagementTable_modalBody__wQZec::-webkit-scrollbar-thumb:hover {
  background: #6bb6d4;
}

@media (max-width: 768px) {
  .ManagementTable_managementPage__gh0bq {
    padding: 1rem;
  }
  .ManagementTable_header__FBHCB {
    flex-direction: column;
    align-items: flex-start;
  }
  .ManagementTable_addButton__Mg3I7 {
    width: 100%;
    justify-content: center;
  }
  .ManagementTable_modal__Tf53U {
    max-width: 100%;
    max-height: calc(100vh - 3rem);
    max-height: calc(100dvh - 3rem);
    margin: 0.5rem;
  }
  .ManagementTable_modalHeader__X95I0 {
    padding: 1rem;
  }
  .ManagementTable_modalTitle__qm0ti {
    font-size: 1rem;
  }
  .ManagementTable_modalBody__wQZec {
    padding: 1rem;
  }
  .ManagementTable_modalFooter__OwhvL {
    padding: 1rem;
    flex-direction: column;
  }
  .ManagementTable_submitButton__YTmtQ,
  .ManagementTable_cancelButton__5HGEM {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/ManagementTable.module.css"],"names":[],"mappings":"AAAA,qFAAqF;;AAErF;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,qBAAqB;EACrB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA,sDAAsD;AACtD;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,0EAA0E;EAC1E,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,iDAAiD;EACjD,qFAAqF;EACrF,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iDAAiD;EACjD,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,4DAA4D;AAC9D;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,yDAAkC;AACpC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,0CAA0C;EAC1C,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;;iDAEiD;AACjD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,0EAA0E;EAC1E,cAAc;EACd,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;EACvB,8CAA8C;EAC9C,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,iDAAiD;EACjD,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,0BAA0B;EAC1B,mBAAmB;EACnB,0CAA0C;EAC1C,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,cAAc;EACd,0CAA0C;EAC1C,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;EACd,0CAA0C;EAC1C,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,8BAA8B;IAC9B,+BAA+B;IAC/B,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;;IAEE,WAAW;EACb;AACF","sourcesContent":["/* Shared table design matching AdminManagement - for use with GenericTable wrapper */\n\n.managementPage {\n  min-height: calc(100vh - 60px);\n  background: #f8f9fa;\n  padding: 1.5rem;\n  color: #000000;\n  width: 100%;\n  max-width: 100%;\n  overflow-x: hidden;\n  box-sizing: border-box;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 1.5rem;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.headerLeft {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.headerIcon {\n  color: #87ceeb;\n}\n\n.title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #000000;\n  margin: 0;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n}\n\n.addButton {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.625rem 1.25rem;\n  background: #000000;\n  color: #ffffff;\n  border: none;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.addButton:hover {\n  background: #001f3f;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n\n.searchBarRow {\n  margin-bottom: 1rem;\n}\n\n.tableContainer {\n  background: #ffffff;\n  border: 1px solid rgba(135, 206, 235, 0.3);\n  border-radius: 0.5rem;\n  overflow-x: auto;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n/* Override Chakra table when inside .tableContainer */\n.tableContainer table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 800px;\n}\n\n.tableContainer thead {\n  background: linear-gradient(135deg, #000000 0%, #001f3f 50%, #000000 100%);\n  color: #ffffff;\n}\n\n.tableContainer thead th {\n  padding: 1rem;\n  text-align: left;\n  font-size: 0.875rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  border-bottom: 2px solid rgba(255, 255, 255, 0.1);\n  background: linear-gradient(135deg, #000000 0%, #001f3f 50%, #000000 100%) !important;\n  color: #ffffff !important;\n  white-space: nowrap;\n  border: none !important;\n}\n\n.tableContainer tbody tr {\n  border-bottom: 1px solid rgba(135, 206, 235, 0.3);\n  transition: all 0.2s ease;\n}\n\n.tableContainer tbody tr:hover {\n  background: rgba(135, 206, 235, 0.05);\n}\n\n.tableContainer tbody td {\n  padding: 1rem;\n  font-size: 0.875rem;\n  color: #000000;\n  white-space: nowrap;\n  border: none !important;\n  border-bottom: 1px solid rgba(135, 206, 235, 0.3) !important;\n}\n\n.tableContainer tbody tr:last-child td {\n  border-bottom: none !important;\n}\n\n.loadingContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n}\n\n.spinner {\n  color: #87ceeb;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n.errorAlert {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 1rem;\n  background: #ff6b6b;\n  color: white;\n  border-radius: 0.5rem;\n  margin-bottom: 1.5rem;\n  font-weight: 500;\n}\n\n/* Action buttons - icon style matching AdminManagement */\n.actionButtons {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.iconButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  background: transparent;\n  border: 1px solid rgba(135, 206, 235, 0.3);\n  border-radius: 0.375rem;\n  color: #000000;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.iconButton:hover {\n  background: rgba(135, 206, 235, 0.1);\n  border-color: #87ceeb;\n  color: #87ceeb;\n}\n\n.iconButton:active {\n  transform: scale(0.95);\n}\n\n.iconButtonDelete:hover {\n  background: rgba(255, 107, 107, 0.1);\n  border-color: #ff6b6b;\n  color: #ff6b6b;\n}\n\n.statusBadge {\n  display: inline-block;\n  padding: 0.25rem 0.75rem;\n  border-radius: 1rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.statusActive {\n  background: rgba(67, 160, 71, 0.1);\n  color: #43a047;\n}\n\n.statusInactive {\n  background: rgba(255, 107, 107, 0.1);\n  color: #ff6b6b;\n}\n\n/* ============================================\n   Modal (AdminManagement-style)\n   ============================================ */\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 1rem;\n  backdrop-filter: blur(2px);\n  -webkit-backdrop-filter: blur(2px);\n}\n\n.modal {\n  background: #ffffff;\n  border-radius: 0.5rem;\n  width: 100%;\n  max-width: 800px;\n  max-height: calc(100vh - 2rem);\n  max-height: calc(100dvh - 2rem);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n}\n\n.modalForm {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.modalHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.25rem 1.5rem;\n  background: linear-gradient(135deg, #000000 0%, #001f3f 50%, #000000 100%);\n  color: #ffffff;\n  border-radius: 0.5rem 0.5rem 0 0;\n  flex-shrink: 0;\n}\n\n.modalTitle {\n  font-size: 1.125rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  margin: 0;\n}\n\n.closeButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  background: transparent;\n  border: none;\n  color: #ffffff;\n  cursor: pointer;\n  border-radius: 0.25rem;\n  transition: all 0.2s ease;\n}\n\n.closeButton:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.modalBody {\n  padding: 1.5rem;\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  overscroll-behavior: contain;\n}\n\n.modalFooter {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  padding: 1.25rem 1.5rem;\n  border-top: 1px solid rgba(135, 206, 235, 0.3);\n  background: #f8f9fa;\n  border-radius: 0 0 0.5rem 0.5rem;\n  flex-shrink: 0;\n}\n\n.formGroup {\n  margin-bottom: 1.25rem;\n}\n\n.formSectionTitle {\n  margin: 0.5rem 0 0.75rem;\n  font-size: 0.8rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: #4a5568;\n  border-bottom: 1px solid rgba(135, 206, 235, 0.3);\n  padding-bottom: 0.35rem;\n}\n\n.formGrid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.75rem 1rem;\n}\n\n.formGrid .formGroup {\n  margin-bottom: 0.5rem;\n}\n\n@media (max-width: 640px) {\n  .formGrid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.label {\n  display: block;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #000000;\n  margin-bottom: 0.5rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.required {\n  color: #ff6b6b;\n}\n\n.input,\n.select {\n  width: 100%;\n  padding: 0.625rem 0.875rem;\n  font-size: 0.875rem;\n  border: 1px solid rgba(135, 206, 235, 0.3);\n  border-radius: 0.375rem;\n  background: #ffffff;\n  color: #000000;\n  transition: all 0.2s ease;\n  box-sizing: border-box;\n}\n\n.input:focus,\n.select:focus {\n  outline: none;\n  border-color: #87ceeb;\n  box-shadow: 0 0 0 3px rgba(135, 206, 235, 0.1);\n}\n\n.input::placeholder {\n  color: #4a5568;\n}\n\n.select {\n  cursor: pointer;\n}\n\n.switchLabel {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  cursor: pointer;\n  padding: 0.5rem 0;\n}\n\n.switch {\n  width: 40px;\n  height: 20px;\n  appearance: none;\n  background: #cbd5e0;\n  border-radius: 10px;\n  position: relative;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n}\n\n.switch:checked {\n  background: #87ceeb;\n}\n\n.switch::before {\n  content: '';\n  position: absolute;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #ffffff;\n  top: 2px;\n  left: 2px;\n  transition: all 0.2s ease;\n}\n\n.switch:checked::before {\n  left: 22px;\n}\n\n.switchText {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #000000;\n}\n\n.helpText {\n  font-size: 0.8125rem;\n  color: #4a5568;\n  margin-left: 0.5rem;\n  font-weight: normal;\n  text-transform: none;\n}\n\n.submitButton {\n  padding: 0.625rem 1.5rem;\n  background: #87ceeb;\n  color: #ffffff;\n  border: none;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.submitButton:hover {\n  background: #6bb6d4;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(135, 206, 235, 0.3);\n}\n\n.submitButton:active {\n  transform: translateY(0);\n}\n\n.cancelButton {\n  padding: 0.625rem 1.5rem;\n  background: transparent;\n  color: #000000;\n  border: 1px solid rgba(135, 206, 235, 0.3);\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.cancelButton:hover {\n  background: rgba(135, 206, 235, 0.1);\n  border-color: #87ceeb;\n}\n\n.formError {\n  padding: 0.875rem 1rem;\n  margin-bottom: 1rem;\n  background: rgba(255, 107, 107, 0.1);\n  color: #ff6b6b;\n  border: 1px solid rgba(255, 107, 107, 0.3);\n  border-radius: 0.5rem;\n  font-size: 0.875rem;\n}\n\n.modalBody::-webkit-scrollbar {\n  width: 8px;\n}\n\n.modalBody::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n.modalBody::-webkit-scrollbar-thumb {\n  background: #87ceeb;\n  border-radius: 4px;\n}\n\n.modalBody::-webkit-scrollbar-thumb:hover {\n  background: #6bb6d4;\n}\n\n@media (max-width: 768px) {\n  .managementPage {\n    padding: 1rem;\n  }\n  .header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  .addButton {\n    width: 100%;\n    justify-content: center;\n  }\n  .modal {\n    max-width: 100%;\n    max-height: calc(100vh - 3rem);\n    max-height: calc(100dvh - 3rem);\n    margin: 0.5rem;\n  }\n  .modalHeader {\n    padding: 1rem;\n  }\n  .modalTitle {\n    font-size: 1rem;\n  }\n  .modalBody {\n    padding: 1rem;\n  }\n  .modalFooter {\n    padding: 1rem;\n    flex-direction: column;\n  }\n  .submitButton,\n  .cancelButton {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"managementPage": `ManagementTable_managementPage__gh0bq`,
	"header": `ManagementTable_header__FBHCB`,
	"headerLeft": `ManagementTable_headerLeft__s5tvl`,
	"headerIcon": `ManagementTable_headerIcon__BHDpe`,
	"title": `ManagementTable_title__cDm3-`,
	"addButton": `ManagementTable_addButton__Mg3I7`,
	"searchBarRow": `ManagementTable_searchBarRow__larbN`,
	"tableContainer": `ManagementTable_tableContainer__jInCR`,
	"loadingContainer": `ManagementTable_loadingContainer__SJ09C`,
	"spinner": `ManagementTable_spinner__4LCqQ`,
	"spin": `ManagementTable_spin__1hb2j`,
	"errorAlert": `ManagementTable_errorAlert__-XloS`,
	"actionButtons": `ManagementTable_actionButtons__HE4hm`,
	"iconButton": `ManagementTable_iconButton__8-wZ-`,
	"iconButtonDelete": `ManagementTable_iconButtonDelete__zFQUu`,
	"statusBadge": `ManagementTable_statusBadge__KoWjt`,
	"statusActive": `ManagementTable_statusActive__6w1zP`,
	"statusInactive": `ManagementTable_statusInactive__cRB7+`,
	"modalOverlay": `ManagementTable_modalOverlay__X0UOm`,
	"modal": `ManagementTable_modal__Tf53U`,
	"modalForm": `ManagementTable_modalForm__aZRkL`,
	"modalHeader": `ManagementTable_modalHeader__X95I0`,
	"modalTitle": `ManagementTable_modalTitle__qm0ti`,
	"closeButton": `ManagementTable_closeButton__aGtsa`,
	"modalBody": `ManagementTable_modalBody__wQZec`,
	"modalFooter": `ManagementTable_modalFooter__OwhvL`,
	"formGroup": `ManagementTable_formGroup__H0bqd`,
	"formSectionTitle": `ManagementTable_formSectionTitle__HR4y2`,
	"formGrid": `ManagementTable_formGrid__RtOoQ`,
	"label": `ManagementTable_label__qzYz7`,
	"required": `ManagementTable_required__BhUVT`,
	"input": `ManagementTable_input__lhDq0`,
	"select": `ManagementTable_select__SBmS3`,
	"switchLabel": `ManagementTable_switchLabel__SmRf-`,
	"switch": `ManagementTable_switch__KVlUn`,
	"switchText": `ManagementTable_switchText__Y4AWq`,
	"helpText": `ManagementTable_helpText__6gv4z`,
	"submitButton": `ManagementTable_submitButton__YTmtQ`,
	"cancelButton": `ManagementTable_cancelButton__5HGEM`,
	"formError": `ManagementTable_formError__11wDE`
};
export default ___CSS_LOADER_EXPORT___;
